import { Button, Flex, Spinner } from '@frontend/components';

import type { PartDescriptorAnnotationActions } from './PartDescriptorActionDataContext';

export const PartDescriptorActionsSet = ({
  partDescriptorActions,
}: {
  partDescriptorActions?: PartDescriptorAnnotationActions | null;
}) => {
  return (
    <Flex
      px={1.5}
      py={1}
      alignItems="center"
      borderTop="1px solid"
      borderColor="separator.divider"
    >
      {partDescriptorActions?.setPartNumber && (
        <Button
          variant="link"
          size="sm"
          onClick={() => partDescriptorActions.setPartNumber?.fn()}
        >
          Set as part number
        </Button>
      )}
      {partDescriptorActions?.setRevision && (
        <Button
          variant="link"
          size="sm"
          onClick={() => partDescriptorActions.setRevision?.fn()}
        >
          Set as revision
        </Button>
      )}
      {partDescriptorActions?.setDescription && (
        <Button
          variant="link"
          size="sm"
          onClick={() => partDescriptorActions.setDescription?.fn()}
        >
          Set as description
        </Button>
      )}
      {Boolean(
        partDescriptorActions?.setPartNumber?.isLoading ||
          partDescriptorActions?.setRevision?.isLoading ||
          partDescriptorActions?.setDescription?.isLoading,
      ) && <Spinner size="sm" ml={1} />}
    </Flex>
  );
};
